module.exports = __webpack_public_path__ + "media/xpopup.1472b5cf.wav";